// Swiper
import Swiper from "swiper";
import { Navigation, Pagination, Thumbs } from "swiper/modules";

// Select galleries but ignore ones already structured correctly
const galleries = document.querySelectorAll(".wp-block-gallery.is-style-slider:not(.swiper-initialized)");

galleries.forEach((gallerySlider) => {
  const existingSwiper = gallerySlider.querySelector(".swiper");
  if (!existingSwiper) {
    const swiperContainer = document.createElement("div");
    swiperContainer.classList.add("swiper");

    const swiperWrapper = document.createElement("div");
    swiperWrapper.classList.add("swiper-wrapper");

    Array.from(gallerySlider.children).forEach((child) => {
      const swiperSlide = document.createElement("div");
      swiperSlide.classList.add("swiper-slide");

      swiperSlide.appendChild(child);
      swiperWrapper.appendChild(swiperSlide);
    });

    swiperContainer.appendChild(swiperWrapper);
    gallerySlider.innerHTML = "";
    gallerySlider.appendChild(swiperContainer);
  }

  // Add navigation if missing
  let navigationContainer = gallerySlider.querySelector(".swiper-slider-navigation");
  if (!navigationContainer) {
    navigationContainer = document.createElement("div");
    navigationContainer.classList.add("swiper-slider-navigation");

    // Caption container (always at the top)
    const captionContainer = document.createElement("div");
    captionContainer.classList.add("swiper-caption");
    captionContainer.textContent = ""; // Initially empty, updated on slide change

    // Wrapper for pagination & navigation buttons
    const controlsContainer = document.createElement("div");
    controlsContainer.classList.add("swiper-controls");

    // Pagination
    const pagination = document.createElement("div");
    pagination.classList.add("swiper-pagination");

    // Previous Button with SVG
    const prevButton = document.createElement("div");
    prevButton.classList.add("swiper-button-prev");
    prevButton.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_16813_1608)">
                    <path d="M3.33325 8H12.6666" stroke="#FAFAFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M3.33325 8L5.99992 10.6667" stroke="#FAFAFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M3.33325 7.99998L5.99992 5.33331" stroke="#FAFAFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_16813_1608">
                        <rect width="16" height="16" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        `;

    // Next Button with SVG
    const nextButton = document.createElement("div");
    nextButton.classList.add("swiper-button-next");
    nextButton.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_16813_1608)">
                    <path d="M3.33325 8H12.6666" stroke="#FAFAFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.6666 8L10 10.6667" stroke="#FAFAFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.6666 8L10 5.33331" stroke="#FAFAFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_16813_1608">
                        <rect width="16" height="16" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        `;

    // Append elements in correct order
    navigationContainer.appendChild(captionContainer); // Caption first
    controlsContainer.appendChild(pagination);
    controlsContainer.appendChild(prevButton);
    controlsContainer.appendChild(nextButton);
    navigationContainer.appendChild(controlsContainer); // Controls grouped
    gallerySlider.appendChild(navigationContainer);
  }

  // Initialize Swiper
  const swiperInstance = new Swiper(gallerySlider.querySelector(".swiper"), {
    centeredSlides: true,
    slidesPerView: 1,
    loop: true,
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: gallerySlider.querySelector(".swiper-button-next"),
      prevEl: gallerySlider.querySelector(".swiper-button-prev"),
    },
    pagination: {
      el: gallerySlider.querySelector(".swiper-pagination"),
      type: "fraction",
    },
    on: {
      init: function (swiper) {
        updateCaption(swiper);
      },
      slideChange: function (swiper) {
        updateCaption(swiper);
      },
    },
  });

  // Function to update caption text
  function updateCaption(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const figcaption = activeSlide.querySelector("figcaption");
    const captionText = figcaption ? figcaption.innerText : "";
    navigationContainer.querySelector(".swiper-caption").textContent = captionText;
  }

  // Mark as initialized
  gallerySlider.classList.add("swiper-initialized");
});

// Slider with thumbnail-strip control (main slider + synced thumbs swiper)
const thumbSliders = document.querySelectorAll(
  ".wp-block-gallery.is-style-slider-thumbs:not(.swiper-initialized)",
);

thumbSliders.forEach((gallerySlider) => {
  let mainEl = gallerySlider.querySelector(".swiper-slider-thumbs-main");
  let thumbsEl = gallerySlider.querySelector(".swiper-slider-thumbs-nav");

  // Build the swiper structure from raw gallery images if not already present
  // (patterns ship raw markup; the editor's save filter only runs when a
  // block is actually edited/saved through the block editor UI).
  if (!mainEl || !thumbsEl) {
    const images = Array.from(gallerySlider.children);

    mainEl = document.createElement("div");
    mainEl.classList.add("swiper", "swiper-slider-thumbs-main");
    const mainWrapper = document.createElement("div");
    mainWrapper.classList.add("swiper-wrapper");
    mainEl.appendChild(mainWrapper);

    thumbsEl = document.createElement("div");
    thumbsEl.classList.add("swiper", "swiper-slider-thumbs-nav");
    const thumbsWrapper = document.createElement("div");
    thumbsWrapper.classList.add("swiper-wrapper");
    thumbsEl.appendChild(thumbsWrapper);

    images.forEach((image) => {
      const mainSlide = document.createElement("div");
      mainSlide.classList.add("swiper-slide");
      mainSlide.appendChild(image);
      mainWrapper.appendChild(mainSlide);

      const thumbSlide = document.createElement("div");
      thumbSlide.classList.add("swiper-slide");
      thumbSlide.appendChild(image.cloneNode(true));
      thumbsWrapper.appendChild(thumbSlide);
    });

    gallerySlider.innerHTML = "";
    gallerySlider.appendChild(mainEl);
    gallerySlider.appendChild(thumbsEl);
  }

  // Nav arrows (styled entirely via CSS, same chevron as .wp-block-details)
  let navigationContainer = gallerySlider.querySelector(".swiper-slider-navigation");
  if (!navigationContainer) {
    navigationContainer = document.createElement("div");
    navigationContainer.classList.add("swiper-slider-navigation");
    navigationContainer.innerHTML = `
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    `;
    gallerySlider.insertBefore(navigationContainer, thumbsEl);
  }
  const prevButton = navigationContainer.querySelector(".swiper-button-prev");
  const nextButton = navigationContainer.querySelector(".swiper-button-next");

  const thumbsSwiper = new Swiper(thumbsEl, {
    slidesPerView: "auto",
    spaceBetween: 8,
    watchSlidesProgress: true,
  });

  new Swiper(mainEl, {
    slidesPerView: 1,
    loop: true,
    modules: [Navigation, Thumbs],
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
  });

  gallerySlider.classList.add("swiper-initialized");
});
